<template>
  <v-btn
    rounded
    :color="value ? 'primary' : 'lightgrey'"
    class=" my-1 mx-2"
    @click="$emit('click')"
  >
    {{ label }}
    <v-chip small class="ml-2">
      {{ number }}
    </v-chip>
  </v-btn>
</template>

<script>
export default {
  name: 'NumberBadge',
  props: {
    label: {
      type: String,
      required: true,
    },
    number: {
      type: Number,
      required: true,
    },
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
